module.exports = __webpack_public_path__ + "static/assets/img/splash-kiosk.857b7bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/splash-kiosk.jpg
// module id = 2pGS
// module chunks = 3